import { TagTheme } from '@/components/Tag/theme';
import { tw } from '@/utils/tw';

const Tag = tw.theme({
  extend: TagTheme,
  defaultVariants: {
    size: 'small',
  },
});

const ArticleFooter = tw.theme({
  slots: {
    base: `flex w-full flex-col gap-4`,
    tags: `mx-auto flex w-full flex-wrap justify-start gap-1.5 md:max-w-article`,
  },
  variants: {
    center: {
      true: {
        tags: `justify-center`,
      },
    },
  },
});

export default Object.assign(ArticleFooter, { Tag });
